import loginTypes from '../login/loginTypes'
import types from './settingTypes'

let initialState = {
    operatorsList: [], // Список операторов с данными
    
    levelUmkdList: [], // Список уровней доступа УМКД оператора

    dictDirectionTrainingList: [], // Справочник направления подготовки
    dictEducationalProgramList: [], // Справочник специализации

    assignedGroupsList: [], // Список распределенных групп (портфолио студента)
    unassignedGroupsList: [], // Список не распределенных групп (портфолио студента)
}

const settingReducer = (state = initialState, action: any) => {
    switch (action.type) {

        // Выход из системы
        case loginTypes.LOGIN_SET_LOGOUT: {
            return {
                ...state = initialState
            }
        }

        // Получение списка операторов системы
        case types.SETTING_SET_OPERATORS: {
            return {
                ...state,
                operatorsList: action.items
            }
        }

        // Получение уровней доступа по УМКД
        case types.SETTING_SET_LEVEL_UMKD: {
            return {
                ...state,
                levelUmkdList: action.items
            }
        }

        // Получение справочника направлений подготовки
        case types.SETTING_SET_DICT_DIRECTION_TRAINING: {
            return {
                ...state,
                dictDirectionTrainingList: action.items
            }
        }

        // Получение справочника образовательные программы
        case types.SETTING_SET_DICT_EDUCATIONAL_PROGRAM: {
            return {
                ...state,
                dictEducationalProgramList: action.items
            }
        }

        // Получение списка распределенных и не распределенных групп
        case types.SETTING_SET_GROUPS: {
            return {
                ...state,
                assignedGroupsList: action.assignedGroupsList,
                unassignedGroupsList: action.unassignedGroupsList
            }
        }

        default: return state
    }
}

export default settingReducer